import { Img } from "./style"

export const NotFound = ()=>{
    return(
        <Img>
           
        </Img>
    )
}